// Ambient motion-art video with dual codecs and a tall (3x4) cut for portrait
// screens: WebM/MP4 tall first when the viewport is portrait, then standard.
const MotionVideo = ({ name, className = "", style = {}, ...rest }) => (
  <video muted loop playsInline className={className} style={style} {...rest}>
    <source media="(max-aspect-ratio: 3/4)" src={`/motion/tall/${name}.webm`} type="video/webm" />
    <source media="(max-aspect-ratio: 3/4)" src={`/motion/tall/${name}.mp4`} type="video/mp4" />
    <source src={`/motion/${name}.webm`} type="video/webm" />
    <source src={`/motion/${name}.mp4`} type="video/mp4" />
  </video>
);

export default MotionVideo;
